import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Form } from 'semantic-ui-react'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { useMultipleMerchandiseItem } from '../../hooks/useMultipleMerchandiseItem'
import List from '../../../commonComponents/List'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import ContainerDetails from './containerDetails'
import { TranslateContext } from '../TranslateContext'
const Container = (props) => {
  
  const key = 'containers'
  const { invoiceId, merchandiseId, lineItemIndex } = props
  const containerInfolist =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.containers) || []
  const {isLoading,AddItem,deleteItem,updateItem,saveItem}=useMultipleMerchandiseItem({tableName:key,invoiceId,merchandiseId});

  const renderItem = useCallback(
    (item) => {
      return (
        <ContainerDetails
          key={item.id}
          item={item}
          saveData={saveItem}
          updateData={updateItem}
          deleteData={deleteItem}
        />
      )
    },
    [saveItem, updateItem, deleteItem]
  )

  const translate = React.useContext(TranslateContext).translate

  return (
    <div className='mb-2' style={{textTransform: 'uppercase'}}>
      <div style={{ textAlign: 'center' }}>
        <span>
          <strong> {translate('CONTAINERS', { ns: ['default', 'header'] })}</strong>
        </span>
      </div>
      <div style={{ border: '1px solid #1765AE' }}>
        <div className='cont_row cont_row--head'>
          <div className='cont_col cont_col--th'>{translate('CONTAINER')}</div>
          <div className='cont_col cont_col--th'>
            {translate('SEAL', { ns: ['default', 'header'] })}
          </div>
          <div className='cont_col cont_col--th'>
            {translate('SIZE', { ns: ['default', 'header'] })}
          </div>
          <div className='cont_col cont_col--th'>
            {translate('QTY', { ns: ['default', 'header'] })}
          </div>
          <div className='cont_col cont_col--th'>
            {translate('WEIGHT', { ns: ['default', 'header'] })}
          </div>
          <div className='cont_col cont_col--th'>
            {translate('DELETE', { ns: ['default', 'header'] })}
          </div>
        </div>
        <Form.Group className='float-container'>
          <List
            dataSource={containerInfolist}
            // isFormEnabled={isFormEnabled}
            renderItem={renderItem}
          />

          {isLoading && <CustomLoader />}
          {
            <AddBtn
              id={`container-add-${invoiceId}-${merchandiseId}`}
              // disabled={isFormEnabled}
              onClick={()=>AddItem({id:" "})}
              text={translate('ADD')}
              style={{marginBottom:'10px'}}
            ></AddBtn>
          }
        </Form.Group>
      </div>
    </div>
  )
}

export default React.memo(Container)
